import { makeStyles } from '@/styles/theme/tss-react';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'GlobalList',
})(({ brandColors, spacing, breakpoints, aspectRatio, typography }, props) => ({
  container: {
    backgroundColor: darkOrLightStyle(props)(
      brandColors.tintsHeroBlue10,
      brandColors.tintsOffWhite60
    ),
  },
  leadImage: {
    aspectRatio: aspectRatio['16/9'],
    width: '100%',
    objectFit: 'cover',
    objectPosition: 'center center',
    margin: `${spacing(3)} 0`,
    borderRadius: typography.pxToRem(16),
    [breakpoints.up('md')]: {
      aspectRatio: aspectRatio['32/9'],
    },
  },
  listHeading: {
    padding: `${spacing(2)} 0`,
    color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
    position: 'relative',
  },
  headingBorder: {
    '&:after': {
      content: '""',
      position: 'absolute',
      width: '100%',
      bottom: 0,
      borderBottom: darkOrLightStyle(props)(
        '1px solid rgba(255, 255, 255, 0.30)',
        '1px solid rgba(0, 0, 0, 0.20)'
      ),
    },
  },
  listContainer: {
    marginBottom: spacing(3),
  },
}));

export default useStyles;
